import React, {useState} from 'react'
import Chart from '@components/chart'
import './index.less'

export default function HomeRight() {
  const [annualOutputChartData, setAnnualOutputChartData] = useState([
    {year: '1991', value: 15468},
    {year: '1992', value: 16100},
    {year: '1993', value: 15900},
    {year: '1994', value: 17409},
    {year: '1995', value: 17000},
    {year: '1996', value: 31056},
    {year: '1997', value: 31982},
    {year: '1998', value: 32040},
    {year: '1999', value: 33233},
  ])
  
  const [lightTypeChartData, setLightTypeChartData] = useState([
    {item: '事例一', count: 40, percent: 0.4},
    {item: '事例二', count: 21, percent: 0.21},
    {item: '事例三', count: 17, percent: 0.17},
    {item: '事例四', count: 13, percent: 0.13},
    {item: '事例五', count: 9, percent: 0.09},
  ])

  // 渲染灯具年产量图
  const renderAnnualOutputChart = (instance, opts) => {
    instance.data(opts.data);
    instance.scale({
      value: {
        min: 10000,
        nice: true,
      },
      year: {
        range: [0, 1],
      },
    });
    instance.tooltip({
      showCrosshairs: true,
      shared: true,
    });

    instance.axis('value', {
      label: {
        formatter: (val) => {
          return (+val / 10000).toFixed(1) + 'k';
        },
      },
    });

    instance.area().position('year*value');
    instance.line().position('year*value');

    instance.render();
  }

  const renderLightTypeChart = (instance, opts) => {
    instance.data(opts.data);
    instance.scale('percent', {
      formatter: (val) => {
        val = val * 100 + '%';
        return val;
      },
    });
    instance.coordinate('theta', {
      radius: 0.75,
      innerRadius: 0.6,
    });
    instance.tooltip({
      showTitle: false,
      showMarkers: false,
      itemTpl: '<li class="g2-tooltip-list-item"><span style="background-color:{color};" class="g2-tooltip-marker"></span>{name}: {value}</li>',
    });
    // 辅助文本
    instance
      .annotation()
      .text({
        position: ['50%', '50%'],
        content: '主机',
        style: {
          fontSize: 14,
          fill: '#8c8c8c',
          textAlign: 'center',
        },
        offsetY: -20,
      })
      .text({
        position: ['50%', '50%'],
        content: '200',
        style: {
          fontSize: 20,
          fill: '#8c8c8c',
          textAlign: 'center',
        },
        offsetX: -10,
        offsetY: 20,
      })
      .text({
        position: ['50%', '50%'],
        content: '台',
        style: {
          fontSize: 14,
          fill: '#8c8c8c',
          textAlign: 'center',
        },
        offsetY: 20,
        offsetX: 20,
      });
    instance
      .interval()
      .adjust('stack')
      .position('percent')
      .color('item')
      .label('percent', (percent) => {
        return {
          content: (data) => {
            return `${data.item}: ${percent * 100}%`;
          },
        };
      })
      .tooltip('item*percent', (item, percent) => {
        percent = percent * 100 + '%';
        return {
          name: item,
          value: percent,
        };
      });

    instance.interaction('element-active');

    instance.render();
  }

  return (
    <div className="light-home-right">
      <div className="light-block">
        <div className="light-block-title">
          灯具年产量
        </div>
        <div className="light-block-con">
          <Chart padding={[24, 16, 24, 48]} renderChart={renderAnnualOutputChart} style={{height: 250}} data={annualOutputChartData} />
        </div>
      </div>
      <div className="light-block">
        <div className="light-block-title">
          灯具类型占比
        </div>
        <div className="light-block-con">
          <Chart padding={[24, 16, 24, 48]} renderChart={renderLightTypeChart} style={{height: 250}} data={lightTypeChartData} />
        </div>
      </div>
      <div className="light-block">
        <div className="light-block-title">
          获奖项目
        </div>
        <div className="light-block-con">
          <Chart padding={[24, 16, 24, 48]} renderChart={renderAnnualOutputChart} style={{height: 250}} data={annualOutputChartData} />
        </div>
      </div>  
    </div>
  )
}